export const ownUpAddress = {
  street: '101 Arch St',
  unit: 'Suite 410',
  city: 'Boston',
  state: 'MA',
  zip: '02110'
};
